/** biome-ignore-all lint/suspicious/noTemplateCurlyInString: Expected */
export const Spanish = {
  BASE: {
    DIALOG_HEADER: {
      BACK: "Atrás",
      CLOSE: "Cerrar",
      REFRESH: "Actualizar",
    },
    DROPDOWN: {
      ALL_ITEMS_SELECTED: "Todos los elementos están seleccionados.",
      CLEAR_SEARCH: "Borrar búsqueda",
      CLEAR: "Borrar",
      NO_OPTIONS: "Sin opciones",
      SEARCH: "Buscar",
      SELECT_ALL: "Seleccionar todos",
      DESELECT_ALL: "Deseleccionar todos",
      CLEAR_ALL: "Borrar todo",
      EXPAND: "Expandir",
      COLLAPSE: "Contraer",
    },
  },
  SEARCH: "Buscar",
  CLEAR_SEARCH: "Borrar búsqueda",
  ACCOUNT_VERIFICATION_ERROR: {
    SKIP: "Omitir",
    VERIFY_EMAIL: "Verifica tu dirección de correo electrónico",
    WE_NOTICED:
      "Notamos que necesitas verificar tu dirección de correo electrónico. Para hacerlo, simplemente haz clic en el botón de abajo.",
    WITHOUT_VERIFICATION:
      "Sin verificación, no podrás acceder a los espacios de trabajo de Hoylu.",
  },
  APP: {
    LOADING_YOUR_WORKSPACE: "Cargando tus espacios de trabajo",
    READ_ONLY: "Solo lectura",
  },
  ASSET_PANEL: {
    USE_EXPANDED_VIEW: "Usar vista extendida",
    USE_COMPACT_VIEW: "Usar vista compacta",
  },
  BETA_DISABLED_CONTENT: {
    BETA_PERIOD_ENDED: "El período beta ha terminado.",
    TAKE_ME: "Llévame a Hoylu",
    THANK_YOU: "Gracias por tu interés en la beta de Hoylu.",
  },
  CENTERED_CONTENT_WITH_LOGO: {
    HOYLU_LOGO: "Logo de Hoylu",
    LEFT_PATH_ICON: "Icono de ruta izquierda",
    RIGHT_PATH_ICON: "Icono de ruta derecha",
  },
  ANALYTICS: {
    TITLE: "Título",
    DESCRIPTION: "Descripción",
    TEAM: "Equipo",
    WEEK: "Semana de inicio",
    START_DATE: "Fecha de inicio",
    END_DATE: "Fecha de fin",
    STATUS: "Estado",
    LABELS: "Etiquetas",
    WORKSPACES: "Espacios de trabajo",
    NO_TEAM: "Sin equipo asignado",
    TASK_LIST: "Lista de tareas ($0)",
    TASK_COUNT: "${0} de ${1}",
    DATE_FROM: "Fecha desde",
    DATE_TO: "Fecha hasta",
    REFRESH: "Actualizar",
    TASKS: "Tareas",
    TOTAL: "Total",
    PERCENT_COMPLETE: "Porcentaje completado",
    COUNT: "Cantidad",
    NO_DATA: "Sin datos",
    LOAD_ERROR: "Error al cargar datos",
    LOCATIONS_TOOLTIP:
      "Mostrar lista de espacios de trabajo en los que está el elemento",
    LOCATIONS_LIST: "Lista de espacios de trabajo",
  },
  CHANGE_MASTER_DIALOG: {
    TITLE: "Vincular plantilla al nuevo espacio de trabajo maestro",
    SUBTITLE:
      "Ingresa el nuevo ID de espacio de trabajo o pega el enlace al nuevo maestro:",
    CANCEL: "Cancelar",
    CHANGE_MASTER: "Cambiar maestro",
  },
  CLOSE_BUTTON: {
    CLOSE: "Cerrar",
  },
  CONFIRMATION_DIALOG: {
    CANCEL: "Cancelar",
    OPTION_ICON: "icono de opción",
    PASSWORD: "Contraseña",
  },
  CONFIRMATION_DRAWER_CONTENT: {
    CANCEL: "Cancelar",
    OPTION_ICON: "icono de opción",
    PASSWORD: "Contraseña",
  },
  DELETE_SCOPE_DIALOG: {
    TITLE: "Eliminar permanentemente todos los datos del proyecto",
    MESSAGE:
      "Esta operación <strong>eliminará permanentemente todos los datos de tareas de este proyecto.</strong>\n" +
      "Los espacios de trabajo basados en este proyecto perderán sus datos como resultado.\n" +
      "Esta acción no se puede deshacer.\n",
    CONFIRM_PROJECT_NAME: "Confirmar nombre del proyecto",
    CONFIRM_DELETE:
      "Confirmo que quiero eliminar permanentemente los datos de este proyecto",
    BUTTON_TEXT: "Eliminar todos los datos",
  },
  COPY_EMAIL_LINK: {
    COPIED_LINK: "Enlace copiado",
    COPY_LINK: "Copiar enlace",
    COPY_WORKSPACE_LINK: "Copiar enlace del espacio de trabajo",
    EMAIL: "Enviar enlace por correo",
    EMAIL_WORKSPACE_LINK: "Enviar enlace del espacio de trabajo por correo",
    LEARN_MORE:
      "Para obtener más información sobre Hoylu y crear una cuenta, visita Hoylu.com.",
    SMALL_COPIED_LINK: "Copiado",
    SMALL_COPY_LINK: "Copiar",
    SMALL_EMAIL: "Correo",
    WORKSPACE_SHARED_WITH_YOU:
      "Se ha compartido contigo un espacio de trabajo de Hoylu.",
  },
  CREATE_WORKSPACES_SECTION: {
    CREATE: "Crear",
    CREATE_WORKSPACE: "Crear espacio de trabajo",
    FROM_TEMPLATE: "Desde plantilla",
    MODULES: {
      BLANK_WORKSPACE: "Espacio de trabajo en blanco",
      BUSINESS_MODEL_CANVAS: "Lienzo de modelo de negocio",
      KANBAN: "Kanban",
      PI_PLANNING: "Planificación PI",
      PULL_PLANNING: "Planificación Pull",
      AGILE_PLANNING: "Planificación ágil",
      RETROSPECTIVE: "Retrospectiva",
      SIMPLE_DRAWING: "Dibujo simple",
      SUPPLY_CHAIN: "Cadena de suministro",
      SWOT_ANALYSIS: "Análisis FODA",
      VALUE_PROPOSITION_CANVAS: "Lienzo de propuesta de valor",
      WEEKLY_PLANNER: "Planificador semanal",
      WORKSPACE_IDEAS: "Ideas de espacios de trabajo",
    },
    OPEN: "Abrir",
    TOOLTIPPOSTFIX: "\n*Función empresarial de Hoylu",
    TOGGLE_SHOW_ALL: "alternar mostrar todos los espacios de trabajo",
    UPSELL: {
      AVAILABLE_WITH_ENTERPRISE:
        "Este módulo está disponible con el plan Enterprise",
      CONTACT_US: "Contáctanos",
      NEED_MORE_WORKSPACES: "¿Necesitas más espacios de trabajo?",
      REACHED_LIMIT:
        "Has alcanzado el límite de espacios de trabajo gratuitos. Actualiza a Hoylu Plus o contacta a tu administrador de proyecto para ser agregado como colaborador a un proyecto y desbloquear espacios de trabajo ilimitados, uso compartido completo y mucho más.\n",
      UPGRADE_TO_ENTERPRISE:
        "Para probarlo, actualiza tu plan a una cuenta Enterprise o contáctanos para una demostración y obtener más información.",
      UPGRADE_TO_PLUS: "Actualizar al plan Plus",
      AVAILABLE_WITH_PLUS: "Esta función está disponible con el plan Plus",
      UNLOCK_WITH_PLUS:
        "Actualiza a Hoylu Plus y desbloquea espacios de trabajo ilimitados, uso compartido completo y mucho más.",
    },
    VIEW_LESS: "ver menos",
    VIEW_MORE: "ver más",
  },
  DELETE_WORKSPACE_DIALOG: {
    CONFIRM_DELETE: "Sí, eliminar permanentemente este espacio de trabajo",
    DELETE: 'Eliminar "${0}"',
    WARNING:
      "¿Estás seguro de que quieres eliminar ${0}? El espacio de trabajo se eliminará de Hoylu inmediatamente. Esto no se puede deshacer.",
  },
  INFO_SECTION_REMOVE_WORKSPACE_DIALOG: {
    HIDE_WORKSPACE:
      "Ocultar espacio de trabajo (permanecerá en el panel como espacio de trabajo oculto)",
    LEAVE_WORKSPACE:
      "Salir del espacio de trabajo (ya no estará disponible en tu panel)",
    DELETE_WORKSPACE:
      "Eliminar espacio de trabajo (elimina permanentemente el espacio de trabajo para TODOS los usuarios)",
    HIDE: "Ocultar espacio de trabajo",
    LEAVE: "Salir del espacio de trabajo",
    DELETE: "Eliminar espacio de trabajo",
    CANCEL: "Cancelar",
    TITLE: "Eliminar espacio de trabajo",
  },
  DELETE_TEMPLATE_DIALOG: {
    TITLE: "Eliminar plantilla",
    SUBTITLE:
      "La plantilla ya no estará disponible en el panel de plantillas. \n" +
      "El espacio de trabajo maestro vinculado volverá a ser un espacio de trabajo normal.",
    CANCEL: "Cancelar",
    CONTINUE: "Continuar",
  },
  DELETE_WORKSPACE_DRAWER: {
    CONFIRM_DELETE: "Sí, eliminar permanentemente este espacio de trabajo",
    DELETE: 'Eliminar "${0}"',
    WARNING:
      "¿Estás seguro de que quieres eliminar ${0}? El espacio de trabajo se eliminará de Hoylu inmediatamente. Esto no se puede deshacer.",
  },
  DUPLICATE_WORKSPACE_DIALOG: {
    CANCEL: "Cancelar",
    COPY_OF: "Copia de",
    COPY_THIS_WORKSPACE: "Copiar este espacio de trabajo",
    DUPLICATE: "Duplicar",
    MAKE_COPY: "Hacer una copia de",
    NEW_WORKSPACE_NAME: "Nuevo nombre del espacio de trabajo",
    OPTION_ICON: "icono de opción",
    PASSWORD: "Contraseña",
    CHARACTERS: "al menos 8 caracteres",
    PRIVATE_WORKSPACE: 'Establecer permiso de compartir enlace en "sin acceso"',
    PRIVATE_WORKSPACE_TOOLTIP:
      "El espacio de trabajo está configurado como privado sin acceso a través del enlace del espacio de trabajo.\n" +
      'Esto se puede cambiar más tarde en la configuración de "compartir" del espacio de trabajo.',
    SHOW_PASSWORD: "mostrar contraseña",
    NEW_PASSWORD: "Nueva contraseña del espacio de trabajo",
  },
  EDIT_LABEL_DIALOG: {
    LABELS: "Etiquetas",
    ENTER_LABEL: "Ingresar etiqueta",
    ADD: "Agregar",
    REMOVE: "Eliminar",
    LOADING: "Cargando",
  },
  ERROR: {
    CANNOT_APPLY_CHANGES:
      "No podemos aplicar tus cambios al espacio de trabajo en este momento. Inténtalo de nuevo más tarde.",
    CANNOT_CREATE_WORKSPACE:
      "No podemos crear un espacio de trabajo en este momento. Inténtalo de nuevo más tarde.",
    CANNOT_DELETE_WORKSPACE:
      "No podemos eliminar este espacio de trabajo. Inténtalo de nuevo más tarde.",
    CANNOT_DUPLICATE_WORKSPACE:
      "No podemos duplicar este espacio de trabajo en este momento. Inténtalo de nuevo más tarde.",
    CANNOT_HIDE_WORKSPACE:
      "No podemos ocultar este espacio de trabajo. Inténtalo de nuevo más tarde.",
    CANNOT_UNHIDE_WORKSPACE:
      "No podemos mostrar este espacio de trabajo. Inténtalo de nuevo más tarde.",
    CANNOT_REMOVE_PASSWORD:
      "No podemos eliminar la contraseña de este espacio de trabajo. Inténtalo de nuevo más tarde.",
    CANNOT_SET_PASSWORD:
      "No podemos establecer una contraseña para este espacio de trabajo. Inténtalo de nuevo más tarde.",
    FAILED_DETECT_TEAMS: "no se pudo configurar los ajustes de equipos",
    INCORRECT_PASSWORD: "Contraseña incorrecta. Inténtalo de nuevo.",
    INCORRECT_WORKSPACE_PASSWORD:
      "Contraseña del espacio de trabajo incorrecta. Inténtalo de nuevo.",
    SOMETHING_WENT_WRONG:
      "Algo salió mal, ¡nuestros ingenieros están trabajando en ello!",
    VERIFY_WORKSPACE_ID:
      "Verifica el ID del espacio de trabajo y que tengas permiso para abrir este espacio de trabajo.",
    WORKSPACE_DELETED: "espacio de trabajo eliminado",
    WORKSPACE_HAS_BEEN_DELETED:
      "El espacio de trabajo que buscas ha sido eliminado. Intenta buscar un espacio de trabajo diferente",
    PROJECTS: {
      INSUFFICIENT_PERMISSIONS_TO_REMOVE_WORKSPACE:
        "No se puede eliminar este espacio de trabajo del proyecto. Permisos insuficientes. Contacta al administrador del proyecto.",
      INSUFFICIENT_PERMISSIONS_TO_ADD_WORKSPACE:
        "No se puede asignar este espacio de trabajo al proyecto. Permisos insuficientes. Contacta al administrador del proyecto.",
      CANNOT_ADD_WORKSPACE:
        "No se puede asignar este espacio de trabajo al proyecto. Razón:",
      REASON_MAX_WORKSPACES:
        "Se alcanzó el límite máximo de espacios de trabajo para este proyecto",
    },
  },
  ERROR_DIALOG: {
    OK: "Aceptar",
  },
  ERROR_FETCHING_WORKSPACE: {
    ERROR_FETCHING_WORKSPACES: "Error al obtener espacios de trabajo",
    TRY_AGAIN: "Intentar de nuevo",
  },
  LOAD_MORE_WORKSPACES: {
    LOAD_MORE: "Cargar más",
  },
  FILTER_BY_NAME: {
    FILTER_BY_NAME: "Filtrar por nombre",
    SEARCH: "Buscar",
    SELECT_PROJECT: "Seleccionar proyecto",
    LOADING_WORKSPACES: "Cargando",
    MAGNIFYING_GLASS: "lupa",
    DASHBOARD: "Panel",
    WORKSPACES: "Espacios de trabajo",
    PROJECT_SETTINGS: "Configuración del proyecto",
    PROJECT_SETTINGS_LABEL: "Abrir configuración del proyecto...",
    NEW_PROJECT: "Nuevo proyecto",
    INACTIVE: "INACTIVO",
  },
  FILTER_BY_WORKSPACE_LABEL: {
    FILTER_BY_LABELS: "Filtrar por etiquetas",
    LOADING_WORKSPACES: "Cargando",
    FILTER: "Filtrar",
    APPLY: "Aplicar",
    INCLUDE_HIDDEN_WORKSPACES: "Mostrar espacios de trabajo ocultos",
  },
  HIDE_WORKSPACE_DIALOG: {
    HIDE: "Ocultar",
    WARNING: "Este espacio de trabajo se ocultará de tu panel",
  },
  LEAVE_WORKSPACE_DIALOG: {
    LEAVE: "Salir",
    WARNING:
      "El espacio de trabajo se eliminará del panel y ya no contará para el límite de crédito.\n" +
      "Si se agregó, también serás eliminado de la lista de permisos del espacio de trabajo.",
  },
  HIDE_WORKSPACE_DRAWER: {
    HIDE: "Ocultar",
    WARNING: "Este espacio de trabajo se ocultará de tu panel",
  },
  HOYLU_LOGO: {
    HOYLU_DASHBOARD: "Panel de Hoylu",
    HOYLU_LOGO: "Logo de Hoylu",
  },
  KANBAN_CONFIGURATION: {
    SET_COLUMNS: "Establecer número de columnas",
  },
  LINKED_MASTER_DIALOG: {
    TITLE: "Espacio de trabajo maestro vinculado",
    SUBTITLE: "La plantilla está actualmente vinculada a:",
    NAME_FIELD: "Nombre del espacio de trabajo:",
    ID_FIELD: "ID del espacio de trabajo:",
    CANCEL: "Cancelar",
    CHANGE_MASTER: "Cambiar maestro",
    EDIT_CONTENT: "Editar contenido",
  },
  LOGIN_PROMPT: {
    AGREE: "Acepto los",
    BACK_TO_LOGIN: "Volver al inicio de sesión",
    ENTER_AS_GUEST: "Entrar como invitado",
    ENTER_EMAIL: "Ingresar correo electrónico",
    JOIN: "Unirse",
    LOGIN: "Iniciar sesión",
    OR: "o",
    SIGN_UP: "Registrarse",
    TERMS: "Términos de uso",
    WELCOME_TO_HOYLU: "Bienvenido a Hoylu",
  },
  LOADING_WORKSPACE_DIALOG: {
    LOADING_WORKSPACE: "Cargando espacio de trabajo",
    LOADED: "cargado",
    PROCESS: "procesado",
    RENDER: "renderizado",
    STEP: "Paso ${0}/${1}",
  },
  MAC_APP: {
    UPSELL_TITLE: "¿Necesitas más espacios de trabajo?",
    UPSELL_TEXT:
      "Has alcanzado el límite de espacios de trabajo disponibles. Visita Hoylu.com o habla con tu administrador para obtener espacios de trabajo adicionales.",
    UPSELL_BUTTON: "Hoylu.com",
  },
  NEW_WORKSPACE_DIALOG: {
    CHARACTERS: "al menos 8 caracteres",
    CONTINUE: "Continuar",
    CREATE_WORKSPACE: "Crear espacio de trabajo",
    PASSWORD: "Contraseña",
    SHOW_PASSWORD: "mostrar contraseña",
    NEW_PASSWORD: "Nueva contraseña del espacio de trabajo",
  },
  NOTIFICATIONS: {
    TITLE: "Notificaciones",
    NAVIGATE_TO_ELEMENT: "Navegar al elemento",
    CLOSE_BUTTON: "Cerrar",
    SHOW_ALL_MESSAGES: "Mostrar todos los mensajes",
    HIDE_READ: "Ocultar leídos",
    MARK_ALL_AS_READ: "Marcar todas las notificaciones como leídas",
    NOTIFICATION_BADGE: "Insignia de notificación",
    SUBSCRIBE:
      "Haz clic aquí para recibir información sobre cambios con notificaciones en la aplicación.\nCtrl + Clic aquí para recibir información en la aplicación y por correos electrónicos de resumen.",
    UNSUBSCRIBE:
      "Haz clic aquí para dejar de recibir notificaciones para este elemento.",
    NO_MORE_MESSAGES: "No hay más mensajes",
  },
  ORG_BANNER: {
    ORGANIZATION_BANNER: "Banner de la organización",
  },
  CREDIT_LIMIT_WARNING_BANNER: {
    TITLE: "Has superado el límite de tu cuenta gratuita.",
    ADD_TO_PROJECT: "agregar al proyecto...",
    BUTTON: "Actualizar",
  },
  ORG_BLOCKED_CREATE_DIALOG: {
    TITLE: "No se puede crear espacio de trabajo",
    TEXT: "Tu organización ha activado la política de permitir solo a los administradores crear un espacio de trabajo. Contacta a un administrador de la organización, que gestiona el acceso a Hoylu, para obtener más detalles.",
  },
  CREDIT_LIMIT_REACHED_DIALOG: {
    TITLE: "Has superado el límite de tu cuenta gratuita.",
    BUTTON_TEXT: "Actualizar",
  },
  TEXT_INPUT: {
    CLEAR: "Borrar",
    TOGGLE_PASSWORD_VISIBILITY: "Alternar visibilidad de contraseña",
  },
  PERMISSION_BAR: {
    ACCESS: "acceso",
    ANYONE_WITH_LINK_IN_ORG:
      "Cualquier persona de mi organización con este enlace",
    AUTHENTICATED_ACCOUNTS_READ_ONLY_ACCESS:
      "Las cuentas autenticadas fuera de la organización tendrán acceso de solo lectura a los espacios de trabajo.\n" +
      "El acceso de solo lectura de invitados (no autenticados) a los espacios de trabajo también está habilitado.",
    AUTHENTICATED_ACCOUNTS_NO_ACCESS:
      "Las cuentas autenticadas fuera de la organización no tendrán acceso a los espacios de trabajo de la organización.\n" +
      "No hay acceso de invitados (no autenticados) a los espacios de trabajo de la organización.",
    HAS: "tiene",
    ONLY_ADMINS_CHANGE_ACCESS:
      "Solo los administradores del espacio de trabajo pueden cambiar los permisos de acceso",
    ONLY_PROJECT_ADMINS_CHANGE_ACCESS:
      "Solo los administradores del proyecto pueden cambiar los permisos de acceso",
    REMOVE_USER: "Eliminar usuario",
    REMOVE_WORKSPACE_ACCESS: "Eliminar usuario del espacio de trabajo",
    REMOVE_PROJECT_WORKSPACE_ACCESS: "Restablecer el acceso",
  },
  PI_CONFIGURATION: {
    SET_ITERATIONS: "Establecer número de iteraciones",
  },
  INVITE_USERS: {
    INVITE_USER: "Invitar usuarios",
    INVITE_USERS_HEADER: "Invitar a Hoylu",
    INVITE_USERS_DESCRIPTION:
      "Ingresa las direcciones de correo electrónico de las personas que te gustaría invitar a unirse a Hoylu.\nSolo se enviarán invitaciones a direcciones de correo electrónico sin una cuenta de Hoylu.",
    INVITE: "Invitar",
    CANCEL: "Cancelar",
    ERR: "Correo electrónico no válido detectado",
    ERR_QTY: "Puedes enviar hasta 10 correos electrónicos a la vez",
    HINT: "Puedes invitar a varias personas pasando múltiples direcciones de correo electrónico separadas por espacios en blanco",
  },
  SHARED_WORKSPACE: {
    ENTER_ID: "Ingresar ID del espacio de trabajo o pegar enlace",
    MAGNIFYING_GLASS: "lupa",
    OPEN: "Abrir",
    OPEN_SHARED_WORKSPACE: "Abrir espacio de trabajo compartido",
  },
  SHARE_TYPE: {
    ADMIN: "admin",
    EDIT: "editar",
    NO_ACCESS: "sin",
    READ: "leer",
    REMOVE: "eliminar",
    ADMIN_TOOLTIP:
      "El usuario tiene acceso completo para configurar y editar el espacio de trabajo.",
    EDIT_TOOLTIP:
      "El usuario puede editar el contenido, pero tiene capacidad limitada para configurar el espacio de trabajo.",
    READ_TOOLTIP:
      "El usuario solo puede ver el contenido del espacio de trabajo pero la configuración de compartir enlaces puede anular esta restricción.",
    NO_ACCESS_TOOLTIP:
      "El usuario no tiene acceso al espacio de trabajo pero la configuración de compartir enlaces puede anular esta restricción.",
    LINK: {
      EDIT_TOOLTIP:
        "Cualquiera con acceso al espacio de trabajo puede editar su contenido.",
      READ_TOOLTIP:
        "Cualquiera con acceso al espacio de trabajo puede leer su contenido.",
      NO_ACCESS_TOOLTIP:
        "Solo los usuarios con permisos explícitos pueden acceder al espacio de trabajo.",
    },
  },
  SHARE_WORKSPACE_DIALOG: {
    ANYONE_WITH_LINK: "Cualquier persona con este enlace",
    LINK_SHARING: "Compartir enlace",
    PERMISSIONS_SECTION: {
      TITLE_PROJECT_WORKSPACE: "Acceso al espacio de trabajo del proyecto",
      TITLE: "Acceso al espacio de trabajo",
    },
    WORKSPACE_INFO: "Título: ${0}",
    CHANGE_THUMBNAIL: "Cambiar miniatura",
    SHARE_THIS_WORKSPACE: "Compartir este espacio de trabajo: ${0}",
    REMOVE_WORKSPACE: "Eliminar espacio de trabajo",
    REMOVE_TEMPLATE: "Eliminar plantilla",
    REMOVE_FROM_PROJECT: "Eliminar del proyecto",
    MANDATORY_FIELD: "Este campo es obligatorio",
    CHARACTER_LIMIT: "El título es demasiado largo",
    WORKSPACE_TITLE: "Título del espacio de trabajo",
    TEMPLATE_TITLE: "Título de la plantilla",
    TEMPLATE_DESCRIPTION_TITLE: "Descripción de la plantilla",
    TEMPLATE_DESCRIPTION_PLACEHOLDER: "Agregar descripción aquí",
    TEMPLATE_CATEGORY_TITLE: "Publicar en categorías",
    TEMPLATE_CATEGORY_PLACEHOLDER: "Categoría",
    TEMPLATE_INFO: "Información de la plantilla",
    LINKED_MASTER: "Maestro vinculado",
    SAVE: "Guardar",
    PUBLISH_AS_TEMPLATE: "Publicar como plantilla",
    PUBLISH_AS_TEMPLATE_NOT_ALLOWED:
      "Este espacio de trabajo está vinculado a otra organización y no se puede publicar.\n" +
      "Para publicar este espacio de trabajo como plantilla, duplícalo y luego publica el duplicado.",
    PUBLISH: "Publicar",
    PROJECT: "Proyecto",
    CANCEL: "Cancelar",
    EDIT: "Editar",
    SAVED: "¡GUARDADO!",
    SAVING: "GUARDANDO...",
    PUBLIC_SHARING: {
      TITLE: "Compartir públicamente & acceso predeterminado",
      NON_MEMBERS: "Los no miembros se añaden al proyecto...",
      SHARE_TYPE: {
        EDIT: "como Colaboradores",
        READ: "como Espectadores",
      },
      CHANGE_SUCCESS: "Acceso al espacio de trabajo puesto al día.",
      TOOLTIP: {
        TITLE: "Activar esta opción resultará en",
        ITEM_1:
          "Haga visible el espacio de trabajo para los miembros del proyecto dentro de la carpeta del proyecto",
        ITEM_2:
          "Comparta el espacio de trabajo con los no miembros del proyecto usando el enlace",
        ITEM_3:
          "Agregar automáticamente a los usuarios que no son miembros al proyecto como Espectadores / Colaboradores",
      },
    },
  },
  SEARCH_WORKSPACE_DIALOG: {
    TITLE: "Buscar espacios de trabajo",
    LABEL: "Etiqueta",
    CANCEL: "Cancelar",
    SEARCH: "Buscar",
    LOADING_WORKSPACES: "Cargando",
  },
  ASSIGN_PROJECT_DIALOG: {
    ASSIGN_TO_PROJECT: "Asignar a proyecto",
    ASSIGN_PROJECT_DESCRIPTION:
      "Asignar un espacio de trabajo a un proyecto hará que este espacio de trabajo aparezca en los paneles de todos los participantes elegibles del proyecto.",
    SELECT_A_PROJECT: "Seleccionar un proyecto",
  },
  REMOVE_WORKSPACE_FROM_PROJECT_DIALOG: {
    TITLE: "Eliminar ${0} del proyecto",
    MESSAGE: "¿Estás seguro de que quieres eliminar ${0} de este proyecto?",
    BUTTON: "Eliminar",
  },
  SHARING_ICONS: {
    COLLAPSE: "Contraer",
    EXPAND: "Expandir",
    LOCKED: "Bloqueado",
    PERMISSIONS: "Permisos",
    UNLOCKED: "Desbloqueado",
    USERS: "Usuarios",
  },
  TEMPLATE_CARD: {
    TILE_IMAGE: "Imagen de mosaico",
  },
  USER_PROFILE_DRAWER: {
    HOYLU_LOGO: "Logo de Hoylu",
    LOGOUT: "Cerrar sesión",
  },
  USER_PROFILE_WIDGET: {
    USER_MARBLE: "Canica del usuario",
    LOGOUT: "Cerrar sesión",
    INVITE_USER: "Invitar usuarios",
    MANAGEMENT_PORTAL: "Portal de gestión",
    SWITCH_COLOR_SCHEME: "Cambiar esquema de colores",
    THEME_LIGHT_TITLE: "Claro",
    THEME_DARK_TITLE: "Oscuro",
    UPLOAD: "Subir",
    MANAGE_ACCOUNT: "Administrar cuenta",
    UPGRADE: "Actualizar",
    LEARN_MORE: "Más información...",
    USAGE_UNDER_LIMIT: "Estás usando el ${0}% \n de tu plan gratuito.",
    USAGE_OVER_LIMIT: "Has superado el \n límite de tu cuenta gratuita.",
    PLAN_TITLE: "(Plan ${0})",
  },
  ANNOUNCEMENTS_DIALOG: {
    TITLE: "Anuncios",
    OK: "ACEPTAR",
    REMIND_ME_LATER: "Recordármelo más tarde",
  },
  WORKSPACE_CARD: {
    HIDDEN_WORKSPACE: "Espacio de trabajo oculto",
    TEMPLATE: "Plantilla de Hoylu",
    MORE_OPTIONS: "Más opciones",
    NOT_YET: "Nunca",
    OPEN: "Abrir",
    UNTITLED: "Sin título",
    WORKSPACE_MODIFIED:
      "Indicador de espacio de trabajo modificado desde el último acceso",
    WORKSPACE_PREVIEW: "vista previa del espacio de trabajo",
    WORKSPACE_IMG_ALT: "Miniatura predeterminada para el espacio de trabajo",
    CHANGES_SINCE: "Cambios desde tu última visita",
    NO_CHANGES_SINCE: "Sin cambios desde tu última visita",
    INACTIVE_PROJECT_LABEL:
      "Este proyecto está inactivo.\nHaz clic para más información.",
    LIMITED_WORKSPACE_LABEL:
      "Se superó el límite de cuenta gratuita.\nNo se pueden agregar nuevos elementos a este espacio de trabajo.\nHaz clic para más información.",
    LIMITED_TITLE: "Limitado",
    DELETE: "Eliminar",
    DELETE_WORKSPACE: "Eliminar espacio de trabajo",
    ASSIGN_PROJECT: "Asignar a proyecto",
    REMOVE_PROJECT: "Eliminar del proyecto",
    DUPLICATE: "Duplicar",
    ADD_LABEL: "Etiqueta",
    LABELS: "Etiquetas",
    DUPLICATE_WORKSPACE: "Duplicar espacio de trabajo",
    LEAVE: "Salir",
    LEAVE_WORKSPACE: "Salir del espacio de trabajo",
    HIDE: "Ocultar",
    HIDE_WORKSPACE: "Ocultar espacio de trabajo",
    UNHIDE: "Mostrar",
    UNHIDE_WORKSPACE: "Mostrar espacio de trabajo",
    ICON: "icono",
    SHARE: "Compartir",
    SHARE_SETTINGS: "Configuración de compartir",
    EDIT_TITLE: "Editar título",
    DOWNLOAD_ARCHIVE: "Descargar archivo",
    WORKSPACE_INFO: "Información del espacio de trabajo",
    EDIT_TEMPLATE: "Editar plantilla",
    EDIT_TEMPLATE_TOOLTIP:
      "Editar espacio de trabajo de plantilla. Ten en cuenta que otros pueden crear duplicados de la plantilla mientras la estás editando si tienen acceso al espacio de trabajo.",
    LOADED: "Cargado",
  },
  WORKSPACE_PASSWORD: {
    ADD_PASSWORD: "Agregar contraseña",
    ADD_WORKSPACE_PASSWORD: "Agregar contraseña del espacio de trabajo:",
    CANCEL: "Cancelar",
    CHANGE: "Cambiar",
    CHANGE_PASSWORD: "Cambiar contraseña",
    CHANGE_WORKSPACE_PASSWORD: "Cambiar contraseña del espacio de trabajo",
    CHARACTERS: "(al menos 8 caracteres)",
    CONFIRM_NEW_PASSWORD: "Confirmar contraseña del espacio de trabajo",
    ENTER_CURRENT_PASSWORD: "Ingresar contraseña actual",
    REMOVE: "Eliminar",
    REMOVE_PASSWORD: "Eliminar contraseña",
    REMOVE_WORKSPACE_PASSWORD: "Eliminar contraseña del espacio de trabajo",
    SET_NEW_PASSWORD: "Establecer contraseña del espacio de trabajo",
    WORKSPACE_NO_PASSWORD: "Sin contraseña establecida",
    WORKSPACE_PASSWORD_SET: "Contraseña del espacio de trabajo establecida",
  },
  WORKSPACE_PERMISSIONS: {
    ADD_USERS: "Agregar usuarios",
    ADD_USERS_TO_PROJECT: "Add Users to Project",
    ADD_WITH_ACCESS: "Agregar con acceso ${0}",
    CANCEL: "Cancelar",
    NOTIFY_USERS: "Notificar a los usuarios por correo electrónico",
    USER_PERMISSION: "El permiso del usuario será",
    BY_POLICY_ANY_ORG_ADMIN: "Por política cualquier administrador de org",
    PROJECT_ADMINS: "Administrador del proyecto",
    ENTER_USER: "Ingresar usuario",
    NO_RESULTS_FOUND: "No se encontraron resultados",
    USE_THIS_ADDRESS: "Usar esta dirección",
    SUGGESTED_USERS: "Usuarios sugeridos",
    LOADING: "Cargando...",
    FAILED_TO_LOAD_USERS: "Error al cargar usuarios.",
    NO_ACCOUNTS_ERROR: "No hay cuentas de Hoylu para los correos electrónicos:",
    INVITE_AND_ADD: "Invitar a Hoylu",
    FIELDS: {
      EMAIL: "correo electrónico",
      NAME: "nombre de usuario",
      PERMISSION: "permiso",
    },
    SORT: {
      BY_X: "Ordenar por ${0}",
      BY_X_ASC: "Ordenar por ${0} (ascendente)",
      BY_X_DSC: "Ordenar por ${0} (descendente)",
    },
  },
  WORKSPACE_TEMPLATES: {
    CREATE: "crear",
    PREVIEW: "vista previa",
    AGILE: "Ágil",
    DESIGN: "Diseño",
    IDEATION: "Ideación",
    BUSINESS: "Negocios",
    TEMPLATES: "Plantillas",
  },
  AGILE_PLANNING: {
    PRESET: "Seleccionar preestablecido",
  },
  DOWNLOAD_DIALOG: {
    DOWNLOAD: "Descargar",
    PASSWORD: "Contraseña",
    SHOW_PASSWORD: "Mostrar contraseña",
    CANCEL: "Cancelar",
    DOWNLOADING: "Descargando...",
    DOWNLOAD_FAILED: "La descarga falló.",
    DOWNLOAD_FAILED_403: "La descarga falló, comprueba la contraseña.",
    TIMESTAMP_LABEL: "Marca de tiempo - tu hora local (opcional)",
    TIMESTAMP_TOOLTIP:
      "Selecciona una marca de tiempo para descargar el espacio de trabajo como estaba en ese momento. Deja vacío para descargar el estado actual.",
  },
  UPLOAD_DIALOG: {
    UPLOADING_WORKSPACE: "Subiendo espacio de trabajo",
    LOADED: "cargado",
    PROCESS: "procesado",
    STEP: "Paso",
    BROWSE: "Examinar",
    ERROR: "Error al subir el espacio de trabajo",
  },
  INSIGHTS_DIALOG: {
    CLOSE: "Cerrar",
    OPEN_IN_NEW_WINDOW: "Abrir Insights en una nueva ventana",
  },
  THUMBNAIL_EDITOR: {
    TITLE: "Miniatura del espacio de trabajo",
    CANCEL: "Cancelar",
    SAVE: "Guardar",
    DELETE: "Eliminar",
    GENERATE_THUMBNAIL: "Generar miniatura",
    TAKE_SNAPSHOT: "Tomar captura",
    TYPE: "Tipo",
    CUSTOM_IMAGE: "Imagen personalizada",
    SNAPSHOT: "Captura",
    BROWSE: "Examinar",
    ERR: "Solo se admiten *.png, *.jpg y *.gif con un tamaño de hasta 1 MB",
  },
  MANAGE_ACCOUNT: {
    TITLE: "Administrar cuenta",
    EMAIL: "Correo electrónico",
    CREATED: "Cuenta creada el: ",
    DELETE: "Eliminar cuenta",
    CLOSE: "Cerrar",
    MANAGE: "Administrar",
  },
  CONFIRM_ACCOUNT_DELETE: {
    TITLE: "Eliminar cuenta: ",
    P1: "Para eliminar tu cuenta:",
    POINT1: "Marca la casilla de confirmación y",
    POINT2: 'Luego haz clic en "Eliminar cuenta".',
    P2: "Recibirás un correo electrónico confirmando que Hoylu ha recibido tu solicitud y un correo electrónico de seguimiento con más información.\nHoylu procederá a eliminar permanentemente tu cuenta en 7 días.",
    CONFIRM: "Confirmo que las cuentas eliminadas no se pueden recuperar",
    DELETE: "Eliminar cuenta",
    CANCEL: "Cancelar",
  },
  SECTIONS: {
    HIDDEN: "Oculto",
    FAVORITES: "Favoritos más recientes",
    PROJECT: {
      COLLABORATORS: "Colaboradores del proyecto",
      PROJECT_SETTINGS: "Configuración del proyecto",
      COPY_LINK: "Copiar enlace al proyecto",
      DASHBOARD: "Panel del proyecto",
      PROJECT_INSIGHTS: "Abrir insights",
      REPORT_TYPE: "Tipo de informe",
      DELETE_SCOPE: "Eliminar todos los datos del proyecto",
      RELOAD: "Recargar",
    },
    START_FROM_TEMPLATE: {
      TITLE: "¡Bienvenido, ${0}!",
      BUTTON: "Explorar plantillas",
      LABEL: "Comenzar desde plantilla",
    },
    WORKSPACES_LIST: "Lista de espacios de trabajo",
  },
  HEADER: {
    NO_ACCESS:
      "Acceso al proyecto denegado. Contacta al administrador del proyecto",
  },
  VALIDATION: {
    MANDATORY_FIELD: "Este campo es obligatorio",
    CHARACTER_LIMIT: "El título es demasiado largo",
  },
  PROJECT: {
    DURATION: "${0} días",
    REMAINING_DURATION: "Duración restante del proyecto: ${0} días",
  },
  HELP_MENU: {
    TOOLTIP: "Ayuda y recursos",
    ANNOUNCEMENTS: {
      TITLE: "Anuncios",
      TOOLTIP: "Noticias y anuncios de Hoylu",
      URL: "https://www.hoylu.com/blog/announcements/",
    },
    GET_STARTED: {
      TITLE: "Comenzar",
      TOOLTIP: "Abrir enlace para comenzar con Hoylu en una nueva pestaña",
      URL: "https://www.hoylu.com/get-started/",
    },
    TUTORIALS: {
      TITLE: "Tutoriales",
      TOOLTIP: "Abrir enlace para ver tutoriales en una nueva pestaña",
      URL: "https://www.hoylu.com/videos/",
    },
    KNOWLEDGE_BASE: {
      TITLE: "Base de conocimientos",
      TOOLTIP:
        "Abrir enlace para ver la base de conocimientos en una nueva pestaña",
      URL: "https://support.hoylu.com",
    },
    PRODUCT_FEEDBACK: {
      TITLE: "Comentarios sobre el producto",
      TOOLTIP:
        "Abrir enlace para proporcionar comentarios sobre el producto en una nueva pestaña",
      URL: "https://support.hoylu.com/hc/en-us/requests/new",
    },
  },
  ZENDESK_WIDGET: {
    TITLE: "¿Necesitas ayuda? Pregunta sobre Hoylu aquí.",
    ARIA_LABEL: "Alternar el widget de soporte de Hoylu",
  },
};
